import { AirDatepickerLocale } from 'air-datepicker';

//TODO: Substituir solução abaixo por uma nativa assim que estiver disponível
export function getDatepickerLocaleProps(
  language: AirDatepickerLocale,
): AirDatepickerLocale {
  const { daysMin, daysShort, ...props } = language;

  const locale = {
    daysMin: daysShort,
    daysShort: daysMin,
    ...props,
  };

  return locale;
}
